module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers-f556f25ce7d9c89b042d6d84695021e3.svg";